<app-header></app-header>


<div class="min-h-screen flex items-center justify-center px-4 sm:px-6 md:px-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employee-login.png)' }">

    <div class="bg-white p-4 sm:p-6 md:p-8 rounded-lg w-full max-w-2xl mt-4 card-shadow">
        <div class="flex justify-start mb-4 sm:mb-6 pb-2 border-b-[1px]">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14" />
        </div>

        <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-2">
            {{ (userType === 'employer' ? 'EMPLOYER.AGREEMENT.TITLE' : 'EMPLOYEE.AGREEMENT.TITLE') | translate }}
        </h2>
        <p class="text-center text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 font-light px-2">
            {{ (userType === 'employer' ? 'EMPLOYER.AGREEMENT.DESCRIPTION' : 'EMPLOYEE.AGREEMENT.DESCRIPTION') |
            translate }}
        </p>

        <!-- Agreement Form -->
        <div *ngIf="!showSuccessScreen" class="flex justify-center px-2">
            <div class="w-full max-w-md space-y-4 sm:space-y-6">
                <!-- Terms & Condition and Privacy Notice -->
                <div class="flex items-start space-x-3 sm:space-x-4">
                    <div class="flex-shrink-0 pt-1">
                        <div class="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center cursor-pointer"
                            [ngClass]="{ 'bg-red-500 border-red-500': termsAndConditionsAccepted, 'bg-white': !termsAndConditionsAccepted }"
                            (click)="termsAndConditionsAccepted = !termsAndConditionsAccepted">
                            <span *ngIf="termsAndConditionsAccepted" class="text-white text-xl">✓</span>
                            <span *ngIf="!termsAndConditionsAccepted" class="text-gray-400 text-2xl">?</span>
                        </div>
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="text-sm sm:text-base text-gray-600 leading-relaxed">
                            {{ (userType === 'employer' ? 'EMPLOYER.AGREEMENT.TERMS_AND_CONDITIONS' :
                            'EMPLOYEE.AGREEMENT.TERMS_AND_CONDITIONS') | translate }}
                            <a href="#"
                                class="text-red-500 font-medium hover:text-red-700 hover:underline transition-colors cursor-pointer inline-flex items-center min-h-[44px]"
                                (click)="openTermsAndConditions($event)">
                                {{ (userType === 'employer' ? 'EMPLOYER.AGREEMENT.TERMS_AND_CONDITIONS_LINK' :
                                'EMPLOYEE.AGREEMENT.TERMS_AND_CONDITIONS_LINK') | translate }}
                            </a>
                        </p>
                    </div>
                </div>

                <!-- Location Usage -->
                <div class="flex items-start space-x-3 sm:space-x-4">
                    <div class="flex-shrink-0 pt-1">
                        <div class="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center cursor-pointer"
                            [ngClass]="{ 'bg-red-500 border-red-500': locationUsageAccepted, 'bg-white': !locationUsageAccepted }"
                            (click)="locationUsageAccepted = !locationUsageAccepted">
                            <span *ngIf="locationUsageAccepted" class="text-white text-xl">✓</span>
                            <span *ngIf="!locationUsageAccepted" class="text-gray-400 text-2xl">?</span>
                        </div>
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="text-sm sm:text-base text-gray-600 leading-relaxed">
                            {{ (userType === 'employer' ? 'EMPLOYER.AGREEMENT.LOCATION_USAGE' :
                            'EMPLOYEE.AGREEMENT.LOCATION_USAGE') | translate }}
                        </p>
                    </div>
                </div>

                <!-- Contact Permission -->
                <div class="flex items-start space-x-3 sm:space-x-4">
                    <div class="flex-shrink-0 pt-1">
                        <div class="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center cursor-pointer"
                            [ngClass]="{ 'bg-red-500 border-red-500': contactPermissionAccepted, 'bg-white': !contactPermissionAccepted }"
                            (click)="contactPermissionAccepted = !contactPermissionAccepted">
                            <span *ngIf="contactPermissionAccepted" class="text-white text-xl">✓</span>
                            <span *ngIf="!contactPermissionAccepted" class="text-gray-400 text-2xl">?</span>
                        </div>
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="text-sm sm:text-base text-gray-600 leading-relaxed">
                            {{ (userType === 'employer' ? 'EMPLOYER.AGREEMENT.CONTACT_PERMISSION' :
                            'EMPLOYEE.AGREEMENT.CONTACT_PERMISSION') | translate }}
                        </p>
                    </div>
                </div>

                <!-- Error Message -->
                <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 text-xs sm:text-sm rounded">
                    {{ errorMessage }}
                </div>

                <!-- Continue Button -->
                <div class="pt-4 sm:pt-6">
                    <button (click)="onContinue()" [disabled]="!areAllCheckboxesChecked() || isLoading"
                        class="w-full rounded-3xl py-3 text-base sm:text-lg font-medium transition-all min-h-[48px]" [ngClass]="{
                            'bg-red-500 text-white': areAllCheckboxesChecked() && !isLoading,
                            'bg-gray-200 text-gray-400 cursor-not-allowed': !areAllCheckboxesChecked() || isLoading
                        }">
                        <span *ngIf="!isLoading">{{ (userType === 'employer' ? 'EMPLOYER.AGREEMENT.CONTINUE_BUTTON' :
                            'EMPLOYEE.AGREEMENT.CONTINUE_BUTTON') | translate }}</span>
                        <span *ngIf="isLoading">PLEASE WAIT...</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Success Screen -->
        <div *ngIf="showSuccessScreen" class="my-6 sm:my-8 text-center px-2">
            <div class="flex justify-center">
                <svg class="w-12 h-12 sm:w-16 sm:h-16 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
            </div>
            <h2 class="text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mt-4">{{ getSuccessTitleKey() | translate }}</h2>
            <p class="text-sm sm:text-base text-gray-500 mt-4">
                {{ getSuccessRedirectMessageKey() | translate }}
            </p>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>

<!-- Modal for Terms and Conditions -->
<div *ngIf="showTermsModal"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 sm:p-6 transition-opacity duration-300"
    [ngClass]="{ 'opacity-100': showTermsModal, 'opacity-0': !showTermsModal }">
    <div class="bg-white rounded-lg shadow-xl w-full max-w-[95vw] sm:max-w-3xl max-h-[90vh] flex flex-col transform transition-transform duration-300"
        [ngClass]="{ 'scale-100': showTermsModal, 'scale-95': !showTermsModal }">
        <div class="p-3 sm:p-4 border-b flex justify-between items-center">
            <h3 class="text-base sm:text-lg md:text-xl font-medium text-gray-800 pr-2">{{ termsData?.title || 'Terms & Conditions and Privacy Notice'
                }}</h3>
            <button (click)="closeTermsModal()"
                class="text-gray-500 hover:text-gray-800 text-2xl sm:text-3xl font-bold min-h-[44px] min-w-[44px] flex items-center justify-center flex-shrink-0">&times;</button>
        </div>
        <div class="p-4 sm:p-6 overflow-y-auto text-sm sm:text-base" style="scroll-behavior: smooth;">
            <!-- Loading state -->
            <div *ngIf="isLoadingTerms" class="flex justify-center items-center py-8">
                <svg class="animate-spin -ml-1 mr-3 h-6 w-6 sm:h-8 sm:w-8 text-red-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                </svg>
                <span class="text-gray-600 text-sm sm:text-base">Loading terms and conditions...</span>
            </div>

            <!-- Terms content -->
            <div *ngIf="!isLoadingTerms && termsData">
                <div *ngIf="termsData.lastUpdated" class="mb-4 p-3 bg-gray-50 rounded-lg">
                    <p class="text-xs sm:text-sm text-gray-500">Last updated: {{ termsData.lastUpdated }}</p>
                </div>

                <div *ngFor="let section of termsData.sections" class="mb-4 sm:mb-6">
                    <h4 class="font-bold text-sm sm:text-base md:text-lg mb-2 sm:mb-3 text-gray-800">{{ section.title }}</h4>
                    <div *ngFor="let paragraph of section.content" class="text-xs sm:text-sm text-gray-600 mb-2 sm:mb-3 leading-relaxed">
                        {{ paragraph }}
                    </div>
                </div>
            </div>

            <!-- Error state -->
            <div *ngIf="!isLoadingTerms && !termsData" class="text-center py-8">
                <p class="text-gray-500 mb-4 text-sm sm:text-base">Unable to load terms and conditions.</p>
                <button (click)="loadTermsAndConditions()"
                    class="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 text-sm sm:text-base min-h-[44px]">
                    Retry
                </button>
            </div>
        </div>
        <div class="p-3 sm:p-4 border-t flex justify-end bg-gray-50 rounded-b-lg">
            <button (click)="closeTermsModal()"
                class="px-4 sm:px-6 py-2 sm:py-3 bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 transition-colors text-sm sm:text-base min-h-[44px]">
                Close
            </button>
        </div>
    </div>
</div>